<script>
  import { Link } from '@inertiajs/svelte'
  import ApplicationLayout from '../../components/ApplicationLayout/index.svelte'

  let { properties, property_types } = $props()

  function pluralize(count, singular) {
    return `${count} ${singular}${count === 1 ? '' : 's'}`
  }
</script>

<svelte:head>
  <title>Properties | Maset</title>
</svelte:head>

<ApplicationLayout>
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-extrabold tracking-tight text-gray-900">Your Properties</h1>
    <Link
      href="/properties/new"
      class="inline-flex items-center gap-2 rounded-lg bg-brand-700 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brand-800 transition-colors"
    >
      + Add Property
    </Link>
  </div>

  {#if properties.length === 0}
    <div class="bg-white border border-gray-200 shadow-sm rounded-2xl p-10 text-center">
      <div class="mx-auto h-12 w-12 rounded-xl bg-brand-50 text-brand-700 grid place-items-center mb-4">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10" />
        </svg>
      </div>
      <p class="text-gray-600 mb-4">You don't have any properties yet.</p>
      <Link
        href="/properties/new"
        class="inline-flex items-center gap-2 rounded-lg bg-brand-700 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brand-800 transition-colors"
      >
        + Add your first property
      </Link>
    </div>
  {:else}
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {#each properties as property}
        <Link
          href={`/properties/${property.id}`}
          class="group block bg-white border border-gray-200 shadow-sm rounded-2xl overflow-hidden hover:border-brand-600 hover:shadow-md transition-all"
        >
          <div class="p-5">
            <div class="flex items-start gap-3">
              <div class="h-10 w-10 flex-shrink-0 rounded-lg bg-brand-50 text-brand-700 grid place-items-center">
                <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10" />
                </svg>
              </div>
              <div class="min-w-0">
                <h2 class="text-base font-bold text-gray-900 truncate group-hover:text-brand-800">{property.name}</h2>
                <p class="text-xs font-semibold text-gray-500 uppercase tracking-wider mt-0.5">
                  {property_types[property.property_type] || property.property_type || 'Not specified'}
                </p>
              </div>
            </div>

            <div class="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
              <span class="flex items-center gap-3 text-sm text-gray-500">
                <span class="inline-flex items-center gap-1.5">
                  <svg class="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>
                  {pluralize(property.items_count || 0, 'item')}
                </span>
                <span class="inline-flex items-center gap-1.5">
                  <svg class="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>
                  {pluralize(property.containers_count || 0, 'container')}
                </span>
              </span>
              <span class="text-sm font-semibold text-brand-700 opacity-0 group-hover:opacity-100 transition-opacity">
                View →
              </span>
            </div>
          </div>
        </Link>
      {/each}
    </div>
  {/if}
</ApplicationLayout>
